@for (participant of participants | slice: 0 : 4; track $index) {
  <lib-avatars [persons]="[participant]" [size]="30" [style.z-index]="10 + $index" class="multi group"></lib-avatars>
}

@if (participants.length > 4) {
  <div
    class="z-20 flex h-[19px] min-h-[19px] w-[19px] min-w-[19px] items-center justify-center self-end rounded-[50%] bg-background-light-blue font-milliard"
  >
    <span class="typo-h8-semibold text-primary-blue group-[.selected]:text-text-white">+{{ participants.length - 4 }}</span>
  </div>
}
